import Tabs from './Tabs';
export default Tabs;
//# sourceMappingURL=index.js.map
